<template>
  <div>
    <v-container grid-list-md text-center>
      <v-form ref="form">
        <v-row>
          <v-text-field
            outlined
            :label="$t(`message.slideNineCommentFieldOne`)"
            v-model="roadways"
            @change="
              setTransportationCommentField({
                field: `roadways`,
                text: roadways
              })
            "
          />
        </v-row>
        <v-row>
          <v-text-field
            outlined
            :label="$t(`message.slideNineCommentFieldTwo`)"
            v-model="safety"
            @change="
              setTransportationCommentField({
                field: `safety`,
                text: safety
              })
            "
          />
        </v-row>
        <v-row>
          <v-text-field
            outlined
            :label="$t(`message.slideNineCommentFieldThree`)"
            v-model="regionalMobility"
            @change="
              setTransportationCommentField({
                field: `regionalMobility`,
                text: regionalMobility
              })
            "
          />
        </v-row>
        <v-row>
          <v-text-field
            outlined
            :label="$t(`message.slideNineCommentFieldFour`)"
            v-model="publicTransportation"
            @change="
              setTransportationCommentField({
                field: `publicTransportation`,
                text: publicTransportation
              })
            "
          />
        </v-row>
        <v-row>
          <v-text-field
            outlined
            :label="$t(`message.slideNineCommentFieldFive`)"
            v-model="activeTransportation"
            @change="
              setTransportationCommentField({
                field: `activeTransportation`,
                text: activeTransportation
              })
            "
          />
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      roadways: "",
      safety: "",
      regionalMobility: "",
      publicTransportation: "",
      activeTransportation: ""
    };
  },
  methods: {
    ...mapActions("response", ["setTransportationCommentField"])
  }
};
</script>
